import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { MunicipalLandUsePlanEntry } from 'app/core/land-use-plan-search/land-use-plan.model';
import { LayerItemDef } from 'app/core/map/layers/layer.model';
import { ZoneEntry } from 'app/core/zone-search/municipality-zone.model';
import { Popup } from 'app/shared/ll/components/popup.component';
import { Bounds } from 'app/shared/ll/models/bounds';
import { _localStorage } from 'app/shared/utils';
import {
    addLandUsePlanPolygon,
    addMeasureAndStopDrawing,
    addZonePolygon,
    boundsChange,
    changeBaseMap,
    clearMeasures,
    hideBubble,
    removeLandUsePlanPolygon,
    removeZonePolygon,
    showBubble,
} from './map.actions';
import { Measure } from './measure.model';


export interface State {
    baseMap: string;
    bounds: Bounds;
    bubble: Popup | null;
    zonePolygons: ZoneEntry[];
    landUsePlanPolygons: MunicipalLandUsePlanEntry[];
    layersDef?: LayerItemDef[];
    measures: Measure[];
}

export const initialState: State = {
    baseMap: _localStorage.getItem('ap-basemap-4') || 'esri-aerial', // todo: @twista - find a way how to improve LS persisting
    bounds: { topLeft: [0, 1], bottomRight: [1, 0], zoom: 13 },
    bubble: null,
    zonePolygons: [],
    landUsePlanPolygons: [],
    measures: [],
};

export const mapReducer = createReducer(
    initialState,
    on(boundsChange, (state, { bounds }) => ({
        ...state,
        bounds,
    })),
    on(changeBaseMap, (state, { baseMap }) => ({
        ...state,
        baseMap,
    })),
    on(showBubble, (state, { bubble }) => ({
        ...state,
        bubble,
    })),
    on(hideBubble, state => ({
        ...state,
        bubble: null,
    })),
    on(addZonePolygon, (state, { zone }) => ({
        ...state,
        zonePolygons: [...state.zonePolygons, zone],
    })),
    on(removeZonePolygon, (state, { index }) => ({
        ...state,
        zonePolygons: state.zonePolygons.filter((_, i) => i !== index),
    })),
    on(addLandUsePlanPolygon, (state, { landUsePlan }) => ({
        ...state,
        landUsePlanPolygons: [...state.landUsePlanPolygons, landUsePlan],
    })),
    on(removeLandUsePlanPolygon, (state, { index }) => ({
        ...state,
        landUsePlanPolygons: state.landUsePlanPolygons.filter((_, i) => i !== index),
    })),
    on(addMeasureAndStopDrawing, (state, { measure }) => ({
        ...state,
        measures: [...state.measures, measure],
    })),
    on(clearMeasures, state => ({
        ...state,
        measures: [],
    })),
);

const selector = createFeatureSelector<State>('map');

export const getBasemap = createSelector(selector, state => state.baseMap);
export const getBounds = createSelector(selector, state => state.bounds);
export const getBubble = createSelector(selector, state => state.bubble);
export const getZonePolygons = createSelector(selector, state => state.zonePolygons);
export const getLandUsePlanPolygons = createSelector(selector, state => state.landUsePlanPolygons);
export const getMeasures = createSelector(selector, state => state.measures);
